module.exports = __webpack_public_path__ + "img/combo-box.82413d93.svg";